export interface SaveQuoteParams {
  projectId: string;
  clientId: string;
  spaceId: string;
  spaceType: "Apartment" | "Room";
  checkIn: string;
  checkOut: string;
}

export const saveQuote = async (
  params: SaveQuoteParams,
  baseClientUri: string,
) => {
  const response = await fetch(`${baseClientUri}/v1/request/rent`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      project_id: params.projectId,
      space_id: params.spaceId,
      client_id: params.clientId,
      checkIn: params.checkIn,
      checkOut: params.checkOut,
      spaceType: params.spaceType,
    }),
  });
  if (!response.ok) {
    throw new Error("error fetching project filters");
  }
  const parsedResponse = await response.json();
  return parsedResponse;
};
